<template>
  <div class="invitation-code">
    <AiInput
      v-model="code"
      :placeholder="$t('placeholderCode')"
      prop="code"
      :error="codeError"
      :maxlength="6"
      @onClearError="onClearError"
    />
    <div class="login-btn-wrap">
      <div class="login-btn" @click="handleInvitefriends">
        {{ $t("confirm") }}
      </div>
    </div>
    <!-- <div class="replace" v-if="getDomain" @click="handleSwitchAccount">
      {{ $t("switchAccount") }}
    </div>
    v-else -->
    <div class="replace" @click="changeAccount">
      {{ $t("switchAccountTitle") }}
    </div>
    <div class="service-wrap" v-if="!getDomain">
      <div class="service-title">{{ $t("noInvitationCode") }}</div>
      <p class="service-desc">{{ $t("wechatScanCode") }}</p>
      <div class="service-img">
        <img src="../../../assets/images/resourcesV2/wechatCode.png" />
      </div>
    </div>
  </div>
</template>
<script>
import { getDomainFn } from "@/utils/env";
import AiInput from "@/components/Input/Index.vue";
import { LocalDataUtil } from "@/common/util";
export default {
  name: "InvitationCode",
  components: {
    AiInput,
  },
  props: {},
  watch: {},
  data() {
    return {
      code: "",
      codeError: "",
    };
  },
  computed: {
    getDomain() {
      return getDomainFn();
    },
  },
  mounted() {},
  methods: {
    changeAccount() {
      LocalDataUtil.removeItem("aispacewebtoken");
      LocalDataUtil.removeItem("aipacewebuserinfo");
      this.$store.commit("setLoginStatus", "SignIn");
    },
    handleSwitchAccount() {
      // LocalDataUtil.removeItem("aispacewebtoken");
      // LocalDataUtil.removeItem("aipacewebuserinfo");
      // this.$store.commit("setLoginStatus", "SignIn");
      let data = LocalDataUtil.getItem("aipacewebuserinfo");
      let userInfo = data ? JSON.parse(data) : {};
      userInfo["invited"] = 1;
      LocalDataUtil.setItem("aipacewebuserinfo", JSON.stringify(userInfo));
      this.$store.commit("setLoginStatus", "SignIn");
      this.$store.commit("setShowLogin", false);
      this.$router.replace("edit");
    },
    onClearError() {
      this.codeError = "";
    },
    async handleInvitefriends() {
      this.codeError = "";
      const params = {
        register_code: this.code,
      };
      const res = await this.$store.dispatch("postInvitefriendsAdd", params);
      if (res.status === "200") {
        if (res.data.code === "50018" || res.data.code === "50019") {
          this.$toast({
            type: "error",
            message: this.$t("invitationCodeError"),
            duration: 5,
          });
          return;
        }
        this.$toast({
          type: "success",
          message: this.$t("success"),
          duration: 5,
        });
        let data = LocalDataUtil.getItem("aipacewebuserinfo");
        let userInfo = data ? JSON.parse(data) : {};
        userInfo["invited"] = 1;
        LocalDataUtil.setItem("aipacewebuserinfo", JSON.stringify(userInfo));
        this.$store.commit("setLoginStatus", "SignIn");
        this.$store.commit("setShowLogin", false);
        this.$router.replace("edit");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.invitation-code {
  padding-top: 30px;
}

.login-btn-wrap {
  padding-top: 7px;
  .login-btn {
    cursor: pointer;
    width: 100%;
    height: 39px;
    background: #8873ff;
    border-radius: 71px;
    font-size: 12px;
    font-family: PingFangTC-Medium, PingFangTC;
    font-weight: 500;
    color: #fff;
    text-align: center;
    line-height: 39px;
    &:active {
      opacity: 0.9;
    }
  }
}

.replace {
  width: 100%;
  height: 15px;
  font-size: 11px;
  font-weight: 400;
  color: rgba(106, 107, 107, 1);
  line-height: 15px;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
  margin-top: 18px;
}
.service-wrap {
  margin-top: 22px;
  border-top: 2px solid #e7e7e7;
  display: flex;
  flex-direction: column;
  align-items: center;
  .service-title {
    font-size: 14px;
    font-weight: bold;
    color: #111111;
    line-height: 14px;
    margin: 22px 0 10px;
  }
  .service-desc {
    font-size: 12px;
    color: rgba(106, 107, 107, 1);
    line-height: 12px;
  }
  .service-img {
    padding: 10px;
    margin: 10px 0 0 0;
    width: 134px;
    height: 134px;
    background: #fff;
    box-shadow: 0px 6px 19px 0px rgba(219, 220, 221, 0.6);
    border-radius: 16px;
  }
}
</style>
